<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div class="main-menu main-menu-desktop clearfix hidden-xs hidden-sm primary-dropdown">
    <div class="container">
      <nav>
        <ul id="category-dropdown">
          <li @mouseenter="getCategoriesMenu">
            <div class="overlaymenu list-menu-categories">
              <div class="dropdown-wrapper">
                <div class="section-left">
                  <ul>
                    <template v-for="(menu, idx) in categoriesOfDepartment">
                      <li
                        v-if="menu.my_soco_sql_id || isLillaCategory(menu.slug)"
                        :key="idx"
                        :class="{ active: menu.name == categoryName }"
                        @mouseover="selectCategory(menu.name)"
                      >
                        <router-link
                          v-if="!isLillaCategory(menu.slug)"
                          :title="menu.name"
                          :to="`/category/${menu.my_soco_sql_id}/${$options.filters.slug(menu.name)}`"
                        >
                          <div style="height: 100%; display: flex; align-items: center; overflow-wrap: wrap">
                            <div
                              style="
                                height: 30px;
                                width: 30px;
                                border-radius: 50%;
                                background-color: gray;
                                margin-right: 8px;
                              "
                            >
                              <img
                                :src="menu.logo || menu.lulla_logo"
                                height="30"
                                width="30"
                                style="border-radius: 50%"
                              />
                            </div>
                            {{ menu.name }}
                          </div>
                        </router-link>
                        <div
                          v-else
                          style="
                            height: 100%;
                            display: flex;
                            align-items: center;
                            overflow-wrap: wrap;
                            gap: 10px;
                            padding: 12px 20px;
                            color: #231f20;
                            text-transform: uppercase;
                          "
                        >
                          <div style="height: 30px; width: 30px; border-radius: 50%; background-color: gray">
                            <img
                              :src="menu.logo || menu.lulla_logo"
                              height="30"
                              width="30"
                              style="border-radius: 50%"
                              :alt="menu.slug"
                            />
                          </div>
                          {{ menu.name }}
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>

                <div class="section-middle" :class="{ 'full-width': isLillaCategory(currentMenuSlug) }">
                  <template v-for="(menu, idx) in categoriesOfDepartment">
                    <div
                      v-if="(menu.my_soco_sql_id || isLillaCategory(menu.slug)) && menu.name == categoryName"
                      :key="idx"
                      class="section-middle__inner"
                    >
                      <div v-if="!isLillaCategory(menu.slug)" class="see-all">
                        <router-link
                          class="textbold"
                          :title="menu.name"
                          :to="`/category/${menu.my_soco_sql_id}/${$options.filters.slug(menu.name)}`"
                        >
                          See All {{ menu.name }}&nbsp;
                          <img
                            src="/assets/img/arrow_carrot-right.svg"
                            alt="icon-next"
                            loading="lazy"
                            width="7"
                            height="8"
                          />
                        </router-link>
                      </div>
                      <ul>
                        <template v-for="(child, idx1) in menu.children">
                          <li v-if="'slug' in child && child.name" :key="idx1">
                            <template v-if="!child.children">
                              <router-link
                                :title="child.name"
                                :to="`/category/${child.my_soco_sql_id}/${$options.filters.slug(child.name)}`"
                                class="parent-no-child"
                              >
                                {{ child.name }}
                              </router-link>
                            </template>
                            <template v-else>
                              <router-link
                                class="textbold"
                                :title="child.name"
                                :to="`/category/${child.my_soco_sql_id}/${$options.filters.slug(child.name)}`"
                              >
                                {{ child.name }}&nbsp;
                                <img
                                  src="/assets/img/arrow_carrot-right.svg"
                                  alt="icon-next"
                                  loading="lazy"
                                  width="7"
                                  height="8"
                                />
                              </router-link>
                            </template>
                            <ul v-if="child.children">
                              <template v-for="(grandChild, idx2) in child.children">
                                <li v-if="grandChild.name" :key="idx2">
                                  <router-link
                                    :title="grandChild.name"
                                    :to="`/category/${grandChild.my_soco_sql_id}/${$options.filters.slug(
                                      grandChild.name
                                    )}`"
                                  >
                                    {{ grandChild.name }}
                                  </router-link>
                                </li>
                              </template>
                            </ul>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </template>
                </div>

                <div v-if="!isLillaCategory(currentMenuSlug)" class="section-right">
                  <template v-if="isLoadingFinishPopularProduct">
                    <h2 class="heading">Popular {{ categoryName }}</h2>
                    <template v-for="(reviewProduct, key) in popularReview">
                      <div v-if="reviewProduct.review_stats.total_reviews !== 0" :key="key" class="small-review">
                        <router-link :to="$options.filters.productUrlReview(reviewProduct)" class="small-review__thumb">
                          <img
                            v-if="reviewProduct.images.length"
                            :src="mainImage(reviewProduct.images[0].url)"
                            class="small-review__img"
                            :alt="reviewProduct.name"
                            loading="lazy"
                          />
                          <img
                            v-else
                            src="/assets/img/dummy_product.svg"
                            class="small-review__img"
                            alt="dummy-product"
                            loading="lazy"
                          />
                        </router-link>
                        <div class="small-review__content">
                          <router-link
                            v-if="reviewProduct.brand"
                            :to="$options.filters.productUrlReview(reviewProduct)"
                            class="small-review__manufacture-name"
                            >{{ reviewProduct.brand.name }}</router-link
                          >
                          <router-link
                            :to="$options.filters.productUrlReview(reviewProduct)"
                            class="small-review__product-name"
                            >{{ reviewProduct.name }}</router-link
                          >
                          <div class="card-rating card-rating--normalize">
                            <div class="rating--uniform timeline-review">
                              <div
                                class="rate-star--uniform"
                                :class="
                                  'rate-star--uniform-' +
                                  $options.filters.rating(reviewProduct.review_stats.average_rating) * 10
                                "
                              >
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                              <span
                                v-if="reviewProduct.review_stats.average_rating"
                                class="small-review__average-rating"
                                >{{ Number(reviewProduct.review_stats.average_rating).toFixed(1) }}</span
                              >
                              <span v-else class="small-review__average-rating">0.0</span>
                              <span class="small-review__total-review"
                                >({{
                                  $options.filters.cnvrtNumberToK(reviewProduct.review_stats.total_reviews) || 0
                                }})</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <loaderspin v-else></loaderspin>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dropdown-category',
  components: {
    loaderspin: () => import('@/shared/UIComponents/LoaderSpin'),
  },
  data() {
    return {
      isLoadingFinishPopularProduct: false,
      showCategoriesOverlay: false,
      loading: false,
      hoveredParentCategoryName: [],
      categoryName: '',
    };
  },
  computed: {
    categoriesOfDepartment() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    categoriesOfDepartmentSelected() {
      return this.$store.state.header.categoriesOfDepartment[this.keyItem];
    },
    popularReview() {
      return this.$store.state.popularReviewPerCategory[this.categoryName];
    },
    activeHeaderMenu() {
      return this.$store.state.activeHeaderMenu;
    },
    showOverlay() {
      return this.$store.state.$_Header.showOverlay;
    },
    currentMenuSlug() {
      const menu = (this.categoriesOfDepartment || []).find((m) => m.name === this.categoryName);
      return menu ? menu.slug : '';
    },
  },
  watch: {
    $route() {
      this.$store.commit('setActiveHeaderMenu', '');
    },
    showOverlay: {
      handler(newVal) {
        if (newVal == true) {
          this.selectCategory(this.$store.state.header.categoriesOfDepartment[0].name);
        }
      },
      immediate: true,
    },
  },
  methods: {
    getCategoriesMenu() {
      if (this.$store.state.$_Header.department_menu.length == 0) {
        this.$store.dispatch('$_Header/getDepartmentMenu', this);
      }
    },
    selectCategory(name) {
      this.categoryName = name;
      if (this.hoveredParentCategoryName.indexOf(name) < 0) {
        this.hoveredParentCategoryName.push(name);
        Promise.all([this.getPopularProduct()]).then().catch();
      }
    },
    async loadChild() {
      if (this.categoriesOfDepartmentSelected && !this.categoriesOfDepartmentSelected.children) {
        return this.$store.dispatch('getChildrenOfDepartments', {
          categoryName: this.item.name,
          categoriesOfDepartmentKey: this.keyItem,
        });
      }
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=72',
        image: src,
      });
    },
    async getPopularProduct() {
      const config = {
        params: {
          filter: { 'categories.name': this.categoryName },
          sort: '-review_stats.total_reviews',
          limit: 2,
        },
        categoryName: this.categoryName,
      };

      return this.$store
        .dispatch('getPopularProductPerCategory', config)
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('setDataPopularReviewPerCategory', {
              data: response.data.data,
              slug: config.categoryName,
            });
          } else {
            this.$store.commit('setDataPopularReviewPerCategory', {
              data: [],
              slug: config.categoryName,
            });
          }
          this.isLoadingFinishPopularProduct = true;
        })
        .catch((err) => {
          this.$store.commit('setDataPopularReviewPerCategory', {
            data: [],
            slug: config.categoryName,
          });
          this.isLoadingFinishPopularProduct = true;
        });
    },
    isLillaCategory(slug) {
      return ['for-moms', 'for-baby-kids'].includes(slug);
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'dropdown-category';
</style>
